module.exports = __webpack_public_path__ + "img/w48.58643bd7.svg";